import jwt2 from 'modules/jwt-2';

const api = jwt2();

export const deleteFile = path => {
  api.delete(R.join('/', ['/files', path]));
};
